<template>
    <div>
        <div class="holder">
            <div class="top-holder">
                <p @click="backBtn()" class="back-text"><span><i class="fa fa-chevron-left"></i></span>Back</p>
                <div class="top-button">
                    <button @click="movetoLandlordAgreement()" class="btn"><img src="../assets/icons/export-upload.svg" alt="export"> Landlord Agreement</button>
                    <button class="btn">Contact Landlord</button>
                </div>
            </div>
            <hr>
            <div class="m-auto text-center mt-4" v-if="loadingLandlord"><Loader/></div>
            <div v-else class="row mt-3">
                <div class="col-6">
                    <div class="info-data">
                        <h6>Email address</h6>
                        <h5>{{landlord.email}}</h5>
                    </div>
                </div>

                <div class="col-6">
                    <div class="info-data">
                        <h6>Phone number</h6>
                        <h5>{{landlord.phone}}</h5>
                    </div>
                </div>
                <div class="col-6">
                    <div class="info-data">
                        <h6>Property owned</h6>
                        <h5>{{ propertyCount }}</h5>
                    </div>
                </div>
                <div class="col-6">
                    <div class="info-data">
                        <h6>Total units</h6>
                        <h5>{{ unitCount }}</h5>
                    </div>
                </div>
                
            </div>
            <hr>

            <div>
                <h4 class="text-header mt-4 mb-4">Property owned</h4>
                <div class="unit-holder">
                    <div class="search-holder">
                        <div class="form-group d-flex justify-content-between">
                            <input class="form-control input-field search" type="text" name="search" id="search" placeholder="Search by id, property or address">
                        </div>
                    </div>
                   
                    <div class="table-responsive tableList">
                    <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Batch No.</th>
                                    <th scope="col">Property Title</th>
                                    <th scope="col">Property Address</th>
                                    <th scope="col">Facility Manager</th>
                                    <th scope="col">Inspec. Officer</th>
                                    <!-- <th scope="col">Vendor</th> -->
                                    <th scope="col">Units</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <div class="m-auto text-center mt-4" v-if="!loadingLandlord"><Loader/></div> -->
                                <tr v-for="(item, index) in properties"
                                :key="index" @click="moveToPropertyOwnedDetails(item.batch)">
                                    <td>{{item.batch}}</td>
                                    <td>{{item.title}} </td>
                                    <td class="break-word">{{item.address}}</td>
                                    <td>{{item.facility_manager ? item.facility_manager.firstname : '--'}} {{item.facility_manager ? item.facility_manager.lastname : '--'}}</td>
                                    <td>{{item.inspection_officer ? item.inspection_officer.firstname : '--'}} {{item.inspection_officer ? item.inspection_officer.lastname : '--'}}</td>
                                    <!-- <td>Victus Banabas</td> -->
                                    <td>{{ item.units }}</td>
                                </tr>
                                
                                <!-- <tr v-for="(item, index) in assingedFMArray"
                                    :key="index"
                                    :value="item.id">
                                    <td>{{index + 1}}</td>
                                    <td>{{item.user.firstname}} {{item.user.lastname}}</td>
                                    <td>{{item.user.email}}</td>
                                    <td>{{item.user.phone}}</td>
                                    <td>{{ item.user.address }}</td>
                                </tr> -->
                            
                            </tbody>
                        </table>
                        <div v-if="properties.length == 0 && !loadingLandlord">
                            <EmptyState :emptyData="emptyDataObject" />
                        </div>
                    </div>
                    <div class="m-auto text-center mt-4" v-if="loadingLandlord"><Loader/></div>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import properties from "../services/properties";
import Loader from '../components/Loader';
import EmptyState from "../components/EmptyState.vue";
export default {
    name: "LandlordDetails",
    components: {
        Loader,
        EmptyState
    },
    data() {
        return {
            loading: false,
            loadingLandlord: false,
            showUnitInfo: false,
            showTenantDetails: false,
            landlordID: "",
            properties: [],
            landlord: '',
            unitCount: "",
            propertyCount: "",
            emptyDataObject: {
                header: 'No record found',
                option: 'No assigned property yet'
            },
        }
    },
    created() {
        this.landlordID = this.$route.params.id;
    },
    mounted() {
        this.fetchPartnersLandlordsDetails();
    },
    methods: {
        backBtn() {
            this.$router.push({path: `/user/partner/property-management`});
        },
        moveToPropertyOwnedDetails(batch) { 
            this.$router.push({path: `/user/partner/landlord-property-details/${batch}`});
        },
        movetoLandlordAgreement() {
            console.log("Clicked")
            // this.$router.push({path: `/user/partner/landlord-agreement`});
        },
        async fetchPartnersLandlordsDetails() {
            this.loadingLandlord = true;
            try {
                if(this.landlordID != '' || this.landlordID != null) {
                    await properties.fetchLandlordDetailsById(this.landlordID).then(res => {
                        // console.log("Landlords details", res);
                        this.loadingLandlord = false;
                        if(res.success) {
                            this.landlord = res.landlord;
                            this.properties = res.properties;
                            this.unitCount = res.units_count;
                            this.propertyCount = res.property_count;

                        }
                        if(res.error) {
                            this.$toast.error(res.error);
                        }
                    }).catch((err) => {
                        this.loadingLandlord = false;
                        console.log(err);
                        // this.$toast.error("please check your network and refresh the page");
                    })
                }
            } finally {
                // console.log("closed");
            }
        }
    },
}
</script>



<style scoped lang="scss">

.top-holder {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    button:first-child {
        margin-right: 10px;
    }
    button {
        img {
            padding-right: 10px;
        }
        border: 1px solid #D5D7DA;
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        color: #414651;
        border-radius: 6px;
        outline: 0;
        box-shadow: none;
    }
}
.holder {
    background: #ffffff;
    padding: 30px 15px;
}
.back-text {
   font-family: Lato;
   font-weight: 600;
   font-size: 16px;
   line-height: 24px;
   color: #535862;
   margin-bottom: 20px !important;
   cursor: pointer;
   span {
      padding-right: 10px;
   }
}
.text-header {
    font-family: Lato;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #2B3352;
}
.info-data {
    margin-bottom: 30px;
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        color: #555C74;
    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #2B3352;
    }
}

.unit-holder {
    border: 1px solid #E9EAEB;
    border-radius: 12px;
}
.search-holder {
    padding: 20px;
}

input, select {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    color: #414651;
}

.input-field {
    height: 48px;
    outline: 0;
    box-shadow: none;
}

.search {
   width: 50%; 
   border-radius: 8px;
}


.table thead th {
    border-bottom: none;
    
}
.table td {
    border-top: 1px solid #EAECF0;
}
.table th {
    border-top: none;
}

thead > tr {
    // background: #EAECF0;
    background: #E9EAEB;
}
thead th {
    white-space: nowrap;
    font-family: Lato;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    // color: #667085
    color: #555C74;
}

tbody td {
    padding: 18px .75rem;
    white-space: nowrap;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #555C74;
    // color: #667085
}


.break-word {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  min-width: 300px;
  width: 100%;
}



@media screen and (max-width: 599px) {
    .search {
      width: 63%; 
    }
    .right-holder {
        margin-top: 40px;
        border-left: none;
        padding-left: none
    }
    .top-holder {
        display: block;
        button {
            margin-bottom: 10px;
        }
    }
}
</style>